const DEFAULT_STORE = 'Jazmin';

const ccyFormat = (num) => {
  if (!num) {
    num = 0
  }
  //return `${num?.toFixed(2)}`;
  // Convertimos el número a una cadena con dos decimales.
  let numStr = num?.toFixed(2);
  // Separamos la parte entera de la parte decimal.
  let [integerPart, decimalPart] = numStr.split('.');
  
  // Usamos una expresión regular para añadir puntos como separadores de miles.
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Reemplazamos el punto decimal por una coma.
  return `${integerPart},${decimalPart}`;
}

const dateFormat = (isoDate) => {
  const date = new Date(isoDate);

  return new Intl.DateTimeFormat("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Para formato de 24 horas
  }).format(date);
}

const viewHour = date => {
  const d = new Date(date);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export {
  DEFAULT_STORE,
  ccyFormat,
  dateFormat,
  viewHour
}